import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import PropTypes from 'prop-types';
import styled from 'styled-components'; // @ts-expect-error convert to TS

import { toScaledPercentage } from './DeviceConstants'; // @ts-expect-error convert to TS

import AbstractDeviceTemplate from './AbstractDeviceTemplate';
const Outer = styled.div.withConfig({
  displayName: "AbstractDeviceFrame__Outer",
  componentId: "sc-5i1qhq-0"
})([""]);
const DisplayWrapper = styled.div.withConfig({
  displayName: "AbstractDeviceFrame__DisplayWrapper",
  componentId: "sc-5i1qhq-1"
})(["border-radius:inherit;display:grid;height:100%;position:relative;width:100%;> *{grid-area:1/1/2/2;}"]);
const Inner = styled.div.withConfig({
  displayName: "AbstractDeviceFrame__Inner",
  componentId: "sc-5i1qhq-2"
})(["margin-bottom:", ";margin-left:", ";margin-right:", ";margin-top:", ";position:absolute;top:0;left:0;right:0;bottom:0;@supports (display:grid){position:relative;}"], props => toScaledPercentage(props.dimensions, 'bottom'), props => toScaledPercentage(props.dimensions, 'left'), props => toScaledPercentage(props.dimensions, 'right'), props => toScaledPercentage(props.dimensions, 'top'));
const ScrollRegion = styled.div.withConfig({
  displayName: "AbstractDeviceFrame__ScrollRegion",
  componentId: "sc-5i1qhq-3"
})(["-ms-overflow-style:-ms-autohiding-scrollbar;overflow-y:auto;position:absolute;top:0;right:0;bottom:0;left:0;"]);

const AbstractDeviceFrame = props => {
  const {
    children,
    className,
    ContentWrapper = AbstractDeviceFrame.defaultProps.ContentWrapper,
    contentClassName,
    InnerWrapper = AbstractDeviceFrame.defaultProps.InnerWrapper,
    OuterWrapper = AbstractDeviceFrame.defaultProps.OuterWrapper,
    spec,
    Template = AbstractDeviceFrame.defaultProps.Template
  } = props,
        rest = _objectWithoutPropertiesLoose(props, ["children", "className", "ContentWrapper", "contentClassName", "InnerWrapper", "OuterWrapper", "spec", "Template"]);

  const renderedTemplate = spec && spec.Template;
  return /*#__PURE__*/_jsx(OuterWrapper, Object.assign({}, rest, {
    className: className,
    children: /*#__PURE__*/_jsxs(DisplayWrapper, {
      children: [/*#__PURE__*/_jsx(Template, {
        dimensions: spec,
        Template: renderedTemplate
      }), /*#__PURE__*/_jsx(InnerWrapper, {
        dimensions: spec,
        children: /*#__PURE__*/_jsx(ContentWrapper, {
          className: contentClassName,
          dimensions: spec,
          children: children
        })
      })]
    })
  }));
};

AbstractDeviceFrame.propTypes = {
  children: PropTypes.node.isRequired,
  ContentWrapper: PropTypes.elementType,
  InnerWrapper: PropTypes.elementType,
  OuterWrapper: PropTypes.elementType,
  spec: PropTypes.object,
  Template: PropTypes.elementType,
  contentClassName: PropTypes.string
};
AbstractDeviceFrame.defaultProps = {
  ContentWrapper: ScrollRegion,
  InnerWrapper: Inner,
  OuterWrapper: Outer,
  Template: AbstractDeviceTemplate
};
AbstractDeviceFrame.displayName = 'AbstractDeviceFrame';
export default AbstractDeviceFrame;